import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "group",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemName').toString(),
        },
        style: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlStyle').toString(),
        },
        tips: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlTips').toString(),
        },
        expand: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.DefaultExpand').toString(),
            default: true,
        },
        align: {
            type: DataType.String,
            title: i18n.t('dataitem.Align').toString(),
        },
    },
};
